var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoreimg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 106 107",
    style: {
      enableBackground: "new 0 0 106 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#2108FF;}\r\n\t.st2{fill:#F2F2F2;}\r\n\t.st3{fill:#210859;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.9,1h86c5.5,0,10,4.5,10,10v86c0,5.5-4.5,10-10,10h-86c-5.5,0-10-4.5-10-10V11C-0.1,5.4,4.3,1,9.9,1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.9,16.7l-49,49c0,0,43,55.1,98.1,0L52.9,16.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.9,24.8L93,65c0,0-15.7,20.1-40.2,20.1C71.7,66.2,40.6,37.1,52.9,24.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M53.1,24.8L13,65c0,0,15.7,20.1,40.2,20.1C74.2,64,40.1,45.2,53.1,24.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoreimg4);
export default __webpack_public_path__ + "static/media/coreimg4.ebde9efb609f7d2ffccd33327384f538.svg";
export { ForwardRef as ReactComponent };